export const asyncLanguages: Record<string, () => unknown> = {
	en: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/rovo-credits-i18n-en" */ './en'),
};
